import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

const Breadcrumbs = ({ items = [] }) => {
  return (
    <nav 
      className="flex items-center gap-2 text-sm text-slate-500 mb-8"
      aria-label="Breadcrumb"
      data-testid="breadcrumbs"
    >
      <Link 
        to="/" 
        className="flex items-center hover:text-teal-600 transition-colors"
      >
        <Home className="w-4 h-4" />
      </Link>
      
      {items.map((item, index) => (
        <div key={index} className="flex items-center gap-2">
          <ChevronRight className="w-4 h-4 text-slate-300" />
          {index === items.length - 1 ? (
            <span className="text-slate-700 font-medium">{item.label}</span>
          ) : (
            <Link 
              to={item.href} 
              className="hover:text-teal-600 transition-colors"
            >
              {item.label}
            </Link>
          )}
        </div>
      ))}
    </nav>
  );
};

export default Breadcrumbs;
